<template>
  <az-call-to-action @click="$emit('enviarParaHomologacao')" active class="text-uppercase">
    {{ textoBotao }}
  </az-call-to-action>
</template>

<script>
export default {
    name: 'BotaoEnviarParaHomologacao',
    computed: {
        identidadeCliente() {
            return this.$store.state.parametros.propriedadesCompraDiretas.identidadeCliente
        },
        textoBotao() {
            return this.identidadeCliente === 'TO'
                ? 'Declarar Vencedor / Enviar para Homologação'
                : 'Enviar para Homologação'
        }
    }
}
</script>